import { toDate } from 'util/date'
import {
  FETCH_CUSTOMER_EVENTS_REQUEST_STARTED,
  FETCH_CUSTOMER_EVENTS_REQUEST_FAILED,
  FETCH_CUSTOMER_EVENTS_REQUEST_SUCCESS,
} from '../types'

const initialState = {
  isLoading: true,
  byCustomerId: {},
}

const reducers = {}

reducers[FETCH_CUSTOMER_EVENTS_REQUEST_STARTED] = state => {
  return Object.assign({}, state, {
    isLoading: true,
  })
}

reducers[FETCH_CUSTOMER_EVENTS_REQUEST_FAILED] = state => {
  return Object.assign({}, state, {
    isLoading: false,
  })
}

reducers[FETCH_CUSTOMER_EVENTS_REQUEST_SUCCESS] = (state, action) => {
  const { payload } = action
  const { customer } = payload
  const { events: { edges } = [] } = customer
  const newByCustomerId = Object.assign({}, state.byCustomerId)

  const nodes = edges.map(edge => {
    const node = edge.node
    node.date = toDate(node.createdAt).toLocaleDateString('en-US')
    return node
  })
  newByCustomerId[customer.id] = nodes

  return Object.assign({}, state, {
    byCustomerId: newByCustomerId,
    isLoading: false,
  })
}

export default function reducer(state = initialState, action) {
  const found = reducers[action.type]
  if (found) return found(state, action)
  return state
}
